function getVariantSets (variantSetIds) {
  if (!this.variantSets) return
  const variantSets = variantSetIds.map(id => this.variantSets[id])
  return variantSets
}

export default getVariantSets